import { observer } from 'mobx-react';
import React from 'react';
import { pagedListResponseUtils, User } from '../../../../domain';
import { TooltipDiv } from '../../../../lib/components';
import { coalesce, concat_ws } from '../../../../lib/helpers';
import { UserSearchStore } from './UserSearchStore';
import PubSub from 'pubsub-js';

const utils = pagedListResponseUtils;

function pagingControls(store: UserSearchStore): React.ReactNode {
  if (store.resultState?.isResolved !== true)
    return null;

  const page = store.resultState.value;

  return (
    <div className="card-header">
      <div className="row  justify-content-center align-items-center">
        <div className="col-auto">
          <button type="button" className="btn btn-sm btn-primary"
            disabled={!utils.hasPreviousPage(page)}
            onClick={store.loadPreviousPage}>
            <span className="fas fa-angle-double-left" />
          </button>
        </div>
        <div className="col-auto">
          Total: {page.CountRecords}.
          Showing from {utils.startIndex(page)} to {utils.endIndex(page)}.
        </div>
        <div className="col-auto">
          <button type="button" className="btn btn-sm btn-primary"
            disabled={!utils.hasNextPage(page)}
            onClick={store.loadNextPage}>
            <span className="fas fa-angle-double-right" />
          </button>
        </div>
      </div>
    </div>
  );
}

function userTooltipContent(user: User): React.ReactNode {
  return (
    <div>
      <div>Username: {user.Username}</div>
      <div>First Name: {user.FirstName}</div>
      <div>Last Name: {user.LastName}</div>
      <div>Email: {user.Email}</div>
    </div>);
}

function results(store: UserSearchStore): React.ReactNode {
  const parent = store.parent;

  const resultState = store.resultState;
  if (resultState?.isResolved !== true)
    return null;

  const page = resultState.value;
  if (page.Data === null || page.Data.length === 0)
    return null;

  const pickable = parent.mode === 'add-classroom' || parent.mode === 'edit-classroom';

  function pickUser(user: User | null) {
    if (store.searchRole === 'Teacher')
      parent.pickTeacher(user);
    if (store.searchRole === 'Student')
      parent.pickStudent(user);
  }

  function openTeacherSchedule(user: User) {
    PubSub.publish("OpenTeacherModal", user);
  }

  let editFormUserId = coalesce(parent.editFormUserId(store.searchRole), -1);
  let selectedUserId = coalesce(store.selectUser?.Id, -1);

  return (
    <div className="card-body">
      <div className="row">
        {
          page.Data!.map(((user) => (
            <div className="col-auto" key={user.Id}>
              <div className="row no-gutters">
                <div className="col-auto">
                  <TooltipDiv className="text-box"
                    tooltipText={userTooltipContent(user)}>
                    {concat_ws([user.FirstName, user.LastName])}
                  </TooltipDiv>
                </div>
                <div className="col-auto">
                  {
                    user.Id !== selectedUserId &&
                    <button type="button" className="btn btn-sm btn-outline-primary"
                      onClick={() => store.setSelectedUser(user)}>
                      <i className="fas fa-filter" />
                    </button>
                  }
                  {
                    pickable &&
                    <button type="button" className="btn btn-sm btn-outline-primary"
                      disabled={user.Id === editFormUserId}
                      onClick={() => pickUser(user)}>
                      <i className="fas fa-check" />
                    </button>
                  }
                  {
                    store.searchRole === 'Teacher' &&
                    <button className="btn btn-primary" onClick={() => openTeacherSchedule(user)}>View Schedule</button>
                  }
                </div>
              </div>
            </div>
          )))
        }
      </div>
    </div>

  );
}

@observer
export class UserSearchResults extends React.Component<{ store: UserSearchStore }> {
  render() {
    const { store } = this.props;

    const expanded = store.expanded && store.resultState !== null;

    if (!expanded)
      return null;

    return (
      <div className="card user-search-results">
        {pagingControls(store)}
        {results(store)}
      </div>
    );
  }
}
